var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4165 3.33268C15.0849 3.33268 14.7669 3.46441 14.5324 3.69888L13.8717 4.35962L15.6398 6.12778L16.3006 5.46704C16.5351 5.23256 16.6668 4.91455 16.6668 4.58296C16.6668 4.25136 16.5351 3.93335 16.3006 3.69888C16.0661 3.46441 15.7481 3.33268 15.4165 3.33268ZM17.4791 6.64555C18.0261 6.09851 18.3334 5.35658 18.3334 4.58296C18.3334 3.80934 18.0261 3.0674 17.4791 2.52037C16.9321 1.97334 16.1901 1.66602 15.4165 1.66602C14.6429 1.66602 13.9009 1.97334 13.3539 2.52037L12.1044 3.76993C12.1045 3.76979 12.1042 3.77008 12.1044 3.76993C12.1042 3.77008 12.1036 3.77066 12.1035 3.7708L1.91058 13.9637C1.7543 14.12 1.6665 14.3319 1.6665 14.553V17.5296C1.6665 17.9899 2.0396 18.363 2.49984 18.363H5.4165C5.63752 18.363 5.84948 18.2752 6.00576 18.1189L17.4791 6.64555ZM14.4613 7.30629L12.6932 5.53814L3.33317 14.8981V16.6963H5.07133L14.4613 7.30629Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.fb37c5c8c6a88af8fd115a132989a473.svg";
export { ForwardRef as ReactComponent };